import './App.css';
import Clients from './components/clients/Clients';
import Details from './components/details/Details';
import { HashRouter, Route, Routes, useParams } from 'react-router-dom';
import Header from './components/header/Header';

function App() {

  let { id } = useParams();
  return (
    <div className="app">
      <div className="container">
        <div className="index">
          <HashRouter basename="/">
            <Header></Header>
            <Routes>
              <Route path="/" element={<Clients />} />
              <Route path=":id" element={<Details />} />
            </Routes>
          </HashRouter>
        </div>
      </div>
    </div>
  );
}

export default App;
